import { forwardRef, useMemo } from 'react';
import { BaseToolbar } from './__internal__';
import { jsx as _jsx } from "react/jsx-runtime";
export const Toolbar = /*#__PURE__*/forwardRef(function Toolbar(props, ref) {
  const items = useMemo(() => {
    const items = props.helpPopup ? [...props.items, {
      type: 'HelpPopup',
      ...props.helpPopup
    }] : props.items;
    return items.map(item => {
      if (item.type === 'ToggleButton') {
        return {
          ...item,
          icon: item.text ? undefined : item.icon,
          // Do not allow icon+text toggle button
          textToDrop: undefined // Do not allow dropping part of the text
        };
      }

      return item;
    });
  }, [props.helpPopup, props.items]);
  return /*#__PURE__*/_jsx(BaseToolbar, {
    ...props,
    items: items,
    ref: ref
  });
});
//# sourceMappingURL=Toolbar.js.map